import { MoCommand } from "./command";

export class NpcSkillCmd extends MoCommand {
    motionIdx: number;

    constructor(object: any, motionIdx: number) {
        super(object);
        this.motionIdx = motionIdx;
    }

    enter() {
        this.object.pawn.playSkillMotion(this.motionIdx, () => {
            this.isComplete = true;
            this.emit("finish");
        });
    }

    leave() {}

    update(delta: number) {
        if (this.wantInterrupt) {
            this.isComplete = true;
            return delta;
        }
        return 0;
    }
}
